/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { CSSProperties, memo, ReactElement } from 'react';

import { ServiceType } from 'shared';

import BabelfishFull from '../assets/images/service-babelfish-full.svg';
import BabelfishMinimal from '../assets/images/service-babelfish-minimal.svg';
import CypexFull from '../assets/images/service-cypex-full.svg';
import CypexMinimal from '../assets/images/service-cypex-minimal.svg';
import MigratorFull from '../assets/images/service-migrator-full.svg';
import MigratorMinimal from '../assets/images/service-migrator-minimal.svg';
import PgeeFull from '../assets/images/service-pgee-full.svg';
import PgeeMinimal from '../assets/images/service-pgee-minimal.svg';
import PostgresFull from '../assets/images/service-postgres-full.svg';
import PostgresMinimal from '../assets/images/service-postgres-minimal.svg';

export const SERVICE_ICONS: Record<ServiceType, Record<'full' | 'minimal', string>> = {
  babelfish: { full: BabelfishFull, minimal: BabelfishMinimal },
  cypex: { full: CypexFull, minimal: CypexMinimal },
  migrator: { full: MigratorFull, minimal: MigratorMinimal },
  pgee: { full: PgeeFull, minimal: PgeeMinimal },
  postgres: { full: PostgresFull, minimal: PostgresMinimal },
};

type Props = {
  serviceType: ServiceType;
  variant?: 'full' | 'minimal';

  width?: number | string | undefined;
  height?: number | string | undefined;
  style?: CSSProperties | undefined;
  id?: string | undefined;
};

const DEFAULT_SIZE = '25px';

export const ServiceIcon = memo((props: Props): ReactElement<any> => {
  const SelectedIcon = SERVICE_ICONS[props.serviceType][props.variant ?? 'full'];
  return (
    <img
      style={props.style}
      src={SelectedIcon}
      id={props.id}
      width={props.width ?? DEFAULT_SIZE}
      height={props.height ?? DEFAULT_SIZE}
    />
  );
});
